import { InfoIconAnchor } from '@/components/formFields/InfoIconAnchor';
import { CaptionLabel } from '@/components/labels/CaptionLabel';
import { Children } from '@/utils/reactTypes';
import Info from '@mui/icons-material/Info';

export const NotesInfoIcon = ({
    headline,
    description,
    children,
}: {
    visibleToClinicians: boolean;
    headline: string;
    description: Children;
    children: Children;
}) => {
    const iconProps = {
        sx: {
            fontSize: 16,
            color: 'primary.main',
        },
    };
    // const icon = visibleToClinicians ? (
    //     // Shield with a health + icon
    //     <HealthAndSafety {...iconProps} />
    // ) : (
    //     // Shield with a little admin user icon
    //     <AdminPanelSettingsSharp {...iconProps} />
    // );
    const icon = <Info {...iconProps} />;
    return (
        <InfoIconAnchor
            icon={icon}
            description={
                <>
                    <CaptionLabel fontWeight={600} display='block'>
                        {headline}
                    </CaptionLabel>
                    {description}
                </>
            }
        >
            {children}
        </InfoIconAnchor>
    );
};
